import React, { useEffect, useState,useRef} from "react";
import { IonSpinner } from "@ionic/react";
import { useLocation, useNavigate, NavLink, useParams } from "react-router-dom";
import API from "../../services";
import './Home.scss'
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import 'swiper/css/pagination';
import { S3_IMG, shouldShowWagerNotice } from "../../constants/common";
import { Autoplay, Pagination } from 'swiper/modules';
import Home from "../../assets/images/Home.svg";
import IplLogo from "../../assets/images/ipl.png";
import { FavoriteOutlined, FavoriteBorderOutlined } from "@mui/icons-material";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif"
import { RootState } from "../../models/RootState";
import { setBanners, setHomeData } from "../../store/authReducer";
import { connect, useSelector } from "react-redux";
import { BannerNavigation, getGameUrl, getTextColorFromCSSVar } from "../../store/authActions";
// import FavoriteOutlinedIcon from '@material-ui/icons/FavoriteOutlined';
import { Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { getEnvVariable, Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import ClassicExchEvents from '../ClassicExchEvents/ClassicExchEvents';
import Inplay from '../../assets/sports/inplay.gif';
import { useTranslation } from "../../hooks/useTranslation";
import WagerNoticeDialog from "../WagerNoticeDialog/WagerNoticeDialog";
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import CSK from "../../assets/images/csk.svg";
import DC from "../../assets/images/dc.svg";
import GT from "../../assets/images/gt.svg";
import KKR from "../../assets/images/kkr.svg";
import LSG from "../../assets/images/lsg.svg";
import MI from "../../assets/images/mi.svg";
import PK from "../../assets/images/pk.svg";
import RR from "../../assets/images/rr.svg";
import RCB from "../../assets/images/rcb.svg";
import SRH from "../../assets/images/srh.svg";
import { themes } from "../WalletComponents/MyProfile/MyProfile";
import {loadColorConfig} from "../../constants/common";
import { updateDynamicTextColors } from "../../store/authActions";
import { setUserDetails } from "../../store/authReducer";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import type { SiteConfig } from "../../models/SiteConfig";
import { demoUser } from "../../utils/StringUtils";

// Add the new types for the marquee content
interface ContentData {
  content: string;
  redirectionUrl: string;
  priority: number;
}

interface ContentResp {
  status: string;
  errorDescription: string;
  data: ContentData[];
}

interface HomePageProps {
    homeData: any;
    banners: any;
    setHomeData: (data: any) => void;
    setBanners: (data: any) => void;
    exchAuthData: any;
    getGameUrl: (provider: any) => void;
    sbAuthData: any;
    activeWallet: any;
    userDetails: any;
    dynamicTextColors: any;
    siteConfig: SiteConfig;
}

type IplTeamKey = "CSK" | "DC" | "GT" | "KKR" | "LSG" | "MI" | "PK" | "RR" | "RCB" | "SRH";

const HomePage: React.FC<HomePageProps> = ({ homeData, setHomeData, banners, setBanners, exchAuthData, getGameUrl, sbAuthData, activeWallet, userDetails, dynamicTextColors, siteConfig }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const browserChannel = useSelector((state: any) => state.userDetails.Browser);
    const [loading, setLoading] = useState<boolean>(false);
    const [gameData, setGameData] = useState<any>();
    const [sectionData, setSectionData] = useState<any>(null);
    const [bannersData, setBannersData] = useState<any>(null);
    const [showPopup, setShowPopup] = useState(false);
    const [fantasyTgPId, setFantasyTgPId] = useState<string>("");
    const [isFantasyGifLoaded, setIsFantasyGifLoaded] = useState<boolean>(false);
    const [pendingGameLink, setPendingGameLink] = useState("");
    const [showWagerNotice, setShowWagerNotice] = useState(false);
    const [pendingWagerGameLink, setPendingWagerGameLink] = useState("");
    const [FAQData, setFAQData] = useState<ContentData[]>([]);
    const [showBetLimitsModal, setShowBetLimitsModal] = useState(false);
    const [selectedGameForBetLimits, setSelectedGameForBetLimits] = useState<any | null>(null);
    const [isIplMenuOpen, setIsIplMenuOpen] = useState(false);
    const [selectedIplThemeKey, setSelectedIplThemeKey] = useState<IplTeamKey | null>(null);
    const iplMenuRef = useRef<HTMLDivElement | null>(null);
    const dispatch = useDispatch();
    const isIplThemeEnabled = !!siteConfig?.isIplThemeEnabled;

    const BrandName = getEnvVariable(domain, 'BRAND_NAME');
    const isKhelo365days = typeof BrandName === 'string' && BrandName.toLowerCase() === 'khelo365days';
    const isMomowin777 = typeof BrandName === 'string' && BrandName.toLowerCase() === 'momowin777';
    const shouldAutoSlideBanners =
        (isKhelo365days || isMomowin777) && Array.isArray(bannersData) && bannersData.length > 1;
    const postLoginAlertPaths = ["/home", "/sports", "/casino", "/site"];
    const shouldPostLoginAlerts = postLoginAlertPaths.some(
      (p) => location.pathname === p || location.pathname.startsWith(p + "/")
    );
    const userIdEmpty = !((userDetails?.UserId || "").trim());
    const telegramWebAccountLinkUrl = (userDetails?.telegramWebAccountLinkUrl || "").trim();
    const shouldShowProfileLoginMarquee =
      userIdEmpty &&
      shouldPostLoginAlerts &&
      !demoUser() &&
      browserChannel !== "TG" &&
      Boolean(telegramWebAccountLinkUrl);

    const iplTeams: Array<{ key: IplTeamKey; name: string; logo: string }> = [
        { key: "PK", name: "Punjab Kings", logo: PK},
        { key: "DC", name: "Delhi Capitals", logo: DC},
        { key: "RR", name: "Rajasthan Royals", logo: RR},
        { key: "CSK", name: "Chennai Super Kings", logo: CSK},
        { key: "SRH", name: "Sunrisers Hyderabad", logo: SRH},
        { key: "KKR", name: "Kolkata Knight Riders", logo: KKR},
        { key: "LSG", name: "Lucknow Super Giants", logo: LSG},
        { key: "MI", name: "Mumbai Indians", logo: MI},
        { key: "GT", name: "Gujarat Titans", logo: GT},
        { key: "RCB", name: "Royal Challengers Bengaluru", logo: RCB},
      ];

    useEffect(() => {
        const themeKeyFromProfile = (userDetails?.Theme || (userDetails as any)?.theme) as IplTeamKey | undefined;
        const isIplTheme = !!themeKeyFromProfile && iplTeams.some((t) => t.key === themeKeyFromProfile);
        setSelectedIplThemeKey(isIplTheme ? themeKeyFromProfile! : null);
    }, [userDetails?.Theme]);

    // Get dynamic text color class from Redux instead of calling function
    const textColorClass = dynamicTextColors?.pageTextColorClass || '';

    // Brand-specific thumbnails for Strike46 site type
    const strike46Thumbnails: Record<string, string> = {
        "ApexWin": "https://cdn.stwin2025.co/TG/BotYaPot/skins/apexwin.png",
        "JkBetsWin": "https://cdn.stwin2025.co/TG/BotYaPot/skins/jkbets.png",
    };

    const getGameThumbnail = (game: any) => {
        if (game?.name === "Strike46" && game?.type === "site" && strike46Thumbnails[BrandName]) {
            return strike46Thumbnails[BrandName];
        }
        return game?.thumbnail;
    };

    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        swipeToSlide: true,
    };


    const getHomeInfo = async () => {
        setLoading(true);

        let response;
        try {
            response = await API.post(`/webapp/get-home-content`, {
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/sports");
        }

        if (response && response.data.sections) {
            setGameData(response.data.sections);
            setFantasyTgPId(response.data.fantasyTgPId)
            // setHomeData(response.data.sections);
        }
        setLoading(false);
    };

    const renderProfileLoginMarquee = () => {
        const ctaText = "Secure passwordless login is now available. Go to My Profile and enable now.";
        const marqueeItems = [ctaText, ctaText, ctaText];
        return (
            <div className="home-header-marquee profile-login-marquee" onClick={() => navigate("/myprofile")}>
                <div className="profile-login-marquee-track" aria-label="Secure login announcement">
                    <div className="profile-login-marquee-group">
                        {marqueeItems.map((item, index) => (
                            <span key={`group-a-${index}`}>{item}</span>
                        ))}
                    </div>
                    <div className="profile-login-marquee-group" aria-hidden="true">
                        {marqueeItems.map((item, index) => (
                            <span key={`group-b-${index}`}>{item}</span>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const changeTheme = async (theme: string, selectedTheme: any): Promise<boolean> => {
        try {
          const response = await API.post(`/users/change-user-theme`, {
            theme: theme,
          });
      
          if (response.data?.status !== "RS_OK") {
            toast.error(response.data?.errorDescription);
            return false;
          }
      
          loadColorConfig(selectedTheme);
      
          // Refresh user details
          try {
            const userKey = sessionStorage.getItem("userKey");
            const detailsResp = await API.post(`/users/get-user-details`, { userKey });
      
            if (detailsResp?.data?.status === "RS_OK") {
              dispatch(setUserDetails(detailsResp.data.userDetails));
            }
          } catch {}
      
          setTimeout(() => {
            dispatch(updateDynamicTextColors() as any);
          }, 100);
      
          return true;
        } catch (e: any) {
          toast.error(e?.response?.data?.errorDescription || "Failed to change theme");
          return false;
        }
      };

      const handleTeamThemeClick = async (teamKey: IplTeamKey) => {
        const selectedTheme = themes[teamKey];
      
        if (!selectedTheme) return;

        // Optimistically highlight selection in the UI
        setSelectedIplThemeKey(teamKey);

        await changeTheme(teamKey, selectedTheme);
      };

      const getIplActionStyle = (index: number, total: number) => {
        // Distribute all teams around the launcher in a full 360° circle.
        const safeTotal = Math.max(1, total);
        const step = 360 / safeTotal;
        const deg = -90 + step * index; // start from top, clockwise
        const rad = (deg * Math.PI) / 180;

        // Centered radial menu: balanced radius for 10 icons
        const radius = safeTotal >= 9 ? 138 : 122;
        const x = Math.cos(rad) * radius;
        const y = Math.sin(rad) * radius;

        return {
          transform: isIplMenuOpen ? `translate(${x}px, ${y}px) scale(1)` : "translate(0px, 0px) scale(0.65)",
          opacity: isIplMenuOpen ? 1 : 0,
          pointerEvents: isIplMenuOpen ? ("auto" as const) : ("none" as const),
          transitionDelay: isIplMenuOpen ? `${index * 45}ms` : "0ms",
        };
      };

      useEffect(() => {
        if (!isIplMenuOpen) return;

        const onKeyDown = (e: KeyboardEvent) => {
          if (e.key === "Escape") setIsIplMenuOpen(false);
        };

        const onPointerDown = (e: PointerEvent) => {
          const el = iplMenuRef.current;
          if (!el) return;
          if (!el.contains(e.target as Node)) {
            setIsIplMenuOpen(false);
          }
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        window.addEventListener("keydown", onKeyDown);
        window.addEventListener("pointerdown", onPointerDown);
        return () => {
          window.removeEventListener("keydown", onKeyDown);
          window.removeEventListener("pointerdown", onPointerDown);
          document.body.style.overflow = prevOverflow;
        };
      }, [isIplMenuOpen]);


    const handleFavoriteClick = async (game: any) => {
        setGameData((prevGameData: any) =>
            prevGameData?.map((section: any) => ({
                ...section,
                items: section?.items?.map((gameMap: any) =>
                    gameMap?.id === game?.id
                        ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                        : gameMap
                ),
            }))
        );
        let response;
        try {
            // Make the API call to update the favorite status
            response = await API.post('/webapp/set-favorite', {
                category: game.category,
                id: game.id,
                isFavorite: !game.isFavorite,
                name: game?.name,
                provider: game?.provider,
                subProvider: game.subProvider,
                thumbnail: game.thumbnail,
                type: game.type,
                tgProviderId: game?.tgProviderId,
                tableId: game?.tableId,
                userKey: sessionStorage.getItem("userKey")
            });

        } catch (error) {
            console.error('Error updating favorite status:', error);
            // Revert the state change if the API call fails
        }

        if (response && response.data?.status === "RS_OK") {
            const updatedGameData = gameData?.map((section: any) => ({
                ...section,
                items: section?.items?.map((gameMap: any) =>
                    gameMap?.id === game?.id
                        ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                        : gameMap
                ),
            }));
            // setHomeData(updatedGameData);
        }
    };

    const getBannerInfo = async () => {

        let response;
        try {
            response = await API.post(`/webapp/get-promotions`, {
                category: "HOME"
            });
        } catch (e) {
            console.log(e);
            return;
        }
        if (response && response.data.promotions) {
            setBannersData(response.data.promotions);
            setBanners(response.data.promotions)
        }
    };

    const handleBannerClick = (banner: any) => {
        if (banner?.redirectionPath && banner.redirectionPath.trim() !== "") {
            BannerNavigation(banner.redirectionPath, navigate);
            return;
        }

        if (banner?.promotionId === "IPL2025") {
            const encodedPath = btoa("4|101480#IPL#EXCHANGE#Competition");
            navigate(`/events/${encodedPath}`);
        } else {
            navigate('/bannerinfo', { state: { banner } });
        }
    };

    const getSportsData = (provider: string) => {
        if (provider === "EXCHANGE") {
            if (!(exchAuthData && exchAuthData?.token)) {
                getGameUrl("EX123");
            }
        }

        if (provider === "SPORTSBOOK") {
            if (!(sbAuthData && sbAuthData?.token)) {
                getGameUrl("SB123");
            }
        }
    }

    useEffect(() => {
        if (homeData && homeData.length > 0) {
            setGameData(homeData);
        } else {
            getHomeInfo();
        }
        if (banners && banners.length > 0) {
            setBannersData(banners);
        } else {
            getBannerInfo();
        }
        if (!(exchAuthData && exchAuthData?.token)) {
            getGameUrl("EX123");
        }
        // getSportsData('EXCHANGE');
        // getSportsData('SPORTSBOOK');
        sessionStorage.setItem("previousPath", location.pathname);
    }, []);

    const gotoSeeAll = (section: any) => {
        navigate("/see-all", { state: { tag: section.sectionTag, title: section.sectionTitle } });
    }

    const handlePlayClick = (game: any, section: any) => {
        let targetLink = '';

        const gameType = game?.type?.toLowerCase();

        if (gameType === 'sport' || gameType === 'competition') {
            targetLink = `/events/${btoa(`${game?.id}#${game?.name}#${game?.provider}#${game?.type}`)}`;
        } else if (gameType === 'event') {
            targetLink = game?.provider === 'EXCHANGE'
                ? `/markets/${btoa(`${game?.id}`)}`
                : `/sb-markets/${btoa(`${game?.id}`)}`;
        } else {
            targetLink = `/play/${btoa(`${game?.id}:${game?.id}:${game?.tgProviderId}:${game?.provider}:${game?.subProvider}:${game?.type}:${game?.category}:${game?.tableId ? game?.tableId : ""}:${game?.isLock}:${section?.isLock}`)}`;
        }

        if (activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled) {
            setPendingGameLink(targetLink);
            setShowPopup(true);
        } else if (shouldShowWagerNotice(game?.is_wager) && !(gameType === 'sport' || gameType === 'competition' || gameType === 'event')) {
            setPendingWagerGameLink(targetLink);
            setShowWagerNotice(true);
        } else {
            navigate(targetLink);
        }
    };

    const handleFantasyClick = () => {
        navigate(`/play/${btoa(`::${fantasyTgPId}::::::::`)}`);
    }

    const handleIplThemeClick = () => {
        navigate('/ipl-themes');
    };


    return (
        <>
            <WagerNoticeDialog
                open={showWagerNotice}
                onCancel={() => {
                    setShowWagerNotice(false);
                    setPendingWagerGameLink("");
                }}
                onProceed={() => {
                    if (pendingWagerGameLink) navigate(pendingWagerGameLink);
                    setShowWagerNotice(false);
                    setPendingWagerGameLink("");
                }}
            />
            <div className={`flex flex-col px-2 sm:px-3 md:px-4 lg:px-6 xl:px-8 mt-2 w-full pb-[7rem] py-[4rem] home max-w-7xl mx-auto ${textColorClass}`}>
                {
                    loading ? (
                        <div className="home-loading">
                            <img src={Loader(domain)} style={{ height: '10rem' }} />
                        </div>
                    ) : (
                        <>
                            {/* <div
                                className="w-full text-white py-1 mb-2 overflow-hidden"
                                onClick={() => navigate("/myprofile")}
                            >
                                <div className="animate-marquee whitespace-nowrap">
                                    🏏 Show your pride! Wear your IPL team's theme. Click here to switch theme 🎨
                                </div>
                            </div> */}
                            {shouldShowProfileLoginMarquee && renderProfileLoginMarquee()}
                            {bannersData && (
                                <div className="banner-section">
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={1}
                                        {...(!isMomowin777
                                            ? {
                                                  breakpoints: {
                                                      640: { slidesPerView: 2, spaceBetween: 10 },
                                                      768: { slidesPerView: 3, spaceBetween: 20 },
                                                      1024: { slidesPerView: 4, spaceBetween: 30 },
                                                  },
                                              }
                                            : {})}
                                        loop={Array.isArray(bannersData) && bannersData.length > 1}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={shouldAutoSlideBanners ? [Pagination, Autoplay] : [Pagination]}
                                        {...(shouldAutoSlideBanners
                                            ? {
                                                  autoplay: {
                                                      delay: 5000,
                                                      disableOnInteraction: false,
                                                  },
                                              }
                                            : {})}
                                    >
                                        {bannersData?.map((banner: any) => (
                                            <SwiperSlide key={banner?.promotionTitle}>
                                                <div style={{ height: '12rem' }}
                                                    onClick={() => handleBannerClick(banner)}
                                                >
                                                    <img
                                                        src={banner?.promotionImage}
                                                        alt="banner"
                                                        style={{ width: '100%', height: '100%', borderRadius: '12px' }}
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )
                            }

                            {
                                fantasyTgPId && (
                                    <div className="mb-2 flex justify-center">
                                        <div
                                            className="flex items-center justify-center w-full cursor-pointer"
                                            onClick={handleFantasyClick}
                                        >
                                            {!isFantasyGifLoaded && (
                                                <div className="rounded-lg fantasy-gif bg-gray-800/60 animate-pulse" />
                                            )}
                                            <img
                                                src={'https://cdn.stwin2025.co/TG/BotYaPot/Fantasy11/fantasy_11.gif'}
                                                className={`rounded-lg fantasy-gif transition-opacity duration-300 ${isFantasyGifLoaded ? 'opacity-100' : 'opacity-0'}`}
                                                onLoad={() => setIsFantasyGifLoaded(true)}
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                )
                            }
                            {exchAuthData && exchAuthData?.token && (
                                <div className="mb-6">
                                    <div className="flex items-center">
                                        <img
                                            src={Inplay}
                                            alt="Live Sports"
                                            className="w-4 sm:w-5 md:w-6 sm:mr-2"
                                            style={{ height: '25px', width: '40px', marginBottom: '8px',marginLeft:'10px' }}
                                        />
                                        <span className={`sports-title text-sm sm:text-base md:text-lg lg:text-xl ${textColorClass}`}>{t("common.sports")}</span>
                                    </div>
                                    <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                        <ClassicExchEvents showOnlyLive={true} maxEventsPerSport={2} compactOdds={true} />
                                    </div>
                                </div>
                            )}
                            <div className="main-section">
                                {gameData?.map((section: any, index: number) => (
                                    section?.items?.length > 0 && (
                                        <div key={index} style={{ marginBottom: '10px' }}>
                                            <div className="flex items-center justify-between pb-3">
                                                <div className="flex items-center">
                                                    <img
                                                        src={
                                                            section?.sectionIcon !== ""
                                                                ? section?.sectionIcon
                                                                : `${S3_IMG}/casino.svg`
                                                        }
                                                        alt={section?.sectionTitle}
                                                        className="w-4 mr-1.5"
                                                    />
                                                    <span className="section-title">{section.sectionTitle}</span>
                                                </div>

                                                {section?.seeAll && (
                                                    <span
                                                        className={`text-xs sm:text-sm md:text-base cursor-pointer ${
                                                            textColorClass === 'dark-text' ? 'text-black' : 'text-white'
                                                        }`}
                                                        onClick={() => {
                                                            gotoSeeAll(section)
                                                        }}
                                                    >
                                                        {t("common.seeAll")}
                                                    </span>
                                                )}
                                            </div>
                                            <Swiper
                                                spaceBetween={10}
                                                slidesPerView={2.7}
                                                breakpoints={{
                                                    480: { slidesPerView: 3, spaceBetween: 14 },
                                                    640: { slidesPerView: 3.5, spaceBetween: 16 },
                                                    768: { slidesPerView: 4, spaceBetween: 18 },
                                                    1024: { slidesPerView: 5, spaceBetween: 20 },
                                                    1280: { slidesPerView: 6, spaceBetween: 22 },
                                                    1536: { slidesPerView: 7, spaceBetween: 24 },
                                                }}
                                                className="game-swiper"
                                            >
                                                {section?.items?.map((game: any, gameIndex: number) => (
                                                    <SwiperSlide key={game?.id + gameIndex}>
                                                        <div onClick={() => handlePlayClick(game, section)} className="cursor-pointer">
                                                            <div
                                                                className={`home-swiper-tile game-tile relative ${(activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled) ? "greyed-out" : ""}`}
                                                            >
                                                                <img
                                                                    src={getGameThumbnail(game)}
                                                                    alt={game?.name}
                                                                    className="w-full h-full rounded-[12px]"
                                                                />
                                                                {section?.sectionTitle !== "Skins" && (
                                                                    <div className="absolute top-[5px] right-[5px]">
                                                                        {game?.isFavorite ? (
                                                                            <FavoriteOutlined
                                                                                className="gold-favourite-img"
                                                                                titleAccess={t("casino.removeFromFavourites")}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleFavoriteClick(game);
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <FavoriteBorderOutlined
                                                                                className="red-favourite-img"
                                                                                titleAccess={t("casino.addToFavourites")}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleFavoriteClick(game);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </div>
                                    )
                                ))}
                            </div>
                            {/* Quick Links Section */}
                            <div className="quick-links-section mt-8 mb-6">
                                <h2 className={`text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                    Quick Links
                                    <div className="w-12 sm:w-16 h-0.5 bg-green-500 mt-1"></div>
                                </h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
                                    <div className="flex flex-col space-y-2 sm:space-y-2">
                                        <button
                                            onClick={() => navigate('/faq')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            FAQs
                                        </button>
                                        <button
                                            onClick={() => navigate('/contact')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Contact Us
                                        </button>
                                        {/* <button
                                            onClick={() => navigate('/rules')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Rules & Regulations
                                        </button> */}
                                        <button
                                            onClick={() => navigate('/trustworthy')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Trustworthy
                                        </button>
                                    </div>
                                    <div className="flex flex-col space-y-2 sm:space-y-2">
                                        <button
                                            onClick={() => navigate('/about')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            About Us
                                        </button>
                                        <button
                                            onClick={() => navigate('/privacypolicy')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Privacy Policy
                                        </button>
                                        {/* <button
                                            onClick={() => navigate('/aml')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            AML Policy
                                        </button> */}
                                    </div>
                                    <div className="flex flex-col space-y-2 sm:space-y-2">
                                        <button
                                            onClick={() => navigate('/responsible-gambling')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Responsible Gambling
                                        </button>
                                        {/* <button
                                            onClick={() => navigate('/exclusion')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Exclusion Policy
                                        </button> */}
                                        <button
                                            onClick={() => navigate('/terms')}
                                            className={`text-left text-sm sm:text-base py-2 sm:py-1 hover:opacity-80 active:opacity-60 transition-opacity ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        >
                                            Terms & Conditions
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* Age Disclaimer and Copyright Section */}
                            <div className="copyright-section mt-6 mb-4 text-center space-y-2">
                                <p className={`text-xs sm:text-sm opacity-70 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                    Users must be 18 years or older to use this platform.
                                </p>
                                <p className={`text-xs sm:text-sm opacity-70 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                    © 2026 {BrandName}. All rights reserved.
                                </p>
                            </div>
                        </>
                    )
                }
                {isIplThemeEnabled && isIplMenuOpen && (
                    <div
                        className="ipl-theme-backdrop"
                        aria-hidden="true"
                        onClick={() => setIsIplMenuOpen(false)}
                    />
                )}

                {isIplThemeEnabled && (
                <div ref={iplMenuRef} className="ipl-theme-menu-root">
                    <div
                        className={`ipl-theme-radial ipl-theme-radial--center ${isIplMenuOpen ? "is-open" : ""}`}
                        aria-hidden={!isIplMenuOpen}
                    >
                        <div className={`ipl-theme-radial__actions ${selectedIplThemeKey ? "has-selection" : ""}`}>
                            {iplTeams.map((team, idx) => (
                                <button
                                    key={team.key}
                                    type="button"
                                        className={`ipl-theme-radial__action ${selectedIplThemeKey === team.key ? "is-selected" : ""}`}
                                    data-team={team.key}
                                    style={getIplActionStyle(idx, iplTeams.length)}
                                    title={team.name}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        await handleTeamThemeClick(team.key);
                                        setIsIplMenuOpen(false);
                                    }}
                                >
                                    <img src={team.logo} alt={team.name} />
                                    {selectedIplThemeKey === team.key && (
                                        <span className="ipl-theme-radial__selectedTag" aria-hidden="true">
                                            {team.key}
                                        </span>
                                    )}
                                </button>
                            ))}
                        </div>
                        <button
                            type="button"
                            className="ipl-theme-radial__centerBtn"
                            aria-label="Close IPL themes"
                            style={{
                                opacity: isIplMenuOpen ? 1 : 0,
                                pointerEvents: isIplMenuOpen ? "auto" : "none",
                                transform: isIplMenuOpen ? "scale(1)" : "scale(0.85)",
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsIplMenuOpen(false);
                            }}
                        >
                            <img src={IplLogo} alt="IPL" />
                        </button>
                    </div>

                    {!isIplMenuOpen && (
                        <div
                            style={{
                                position: "fixed",
                                top: isKhelo365days ? "80%" : "50%",
                                right: "15px",
                                zIndex: 1000,
                            }}
                        >
                            <button
                                type="button"
                                className="ipl-theme-fab"
                                aria-label="IPL Themes"
                                aria-expanded={isIplMenuOpen}
                                onClick={() => setIsIplMenuOpen((v) => !v)}
                            >
                                <div className="ipl-theme-fab-inner">
                                    <img src={IplLogo} alt="IPL Theme" />
                                    <span
                                        className={`ipl-theme-fab-label ${
                                            textColorClass === "dark-text" ? "text-black" : "text-white"
                                        }`}
                                    >
                                        IPL Theme
                                    </span>
                                </div>
                            </button>
                        </div>
                    )}
                </div>
                )}
            </div>

            {showPopup && (
                <Dialog
                    fullScreen={false}
                    open={showPopup}
                    onClose={() => {
                        setShowPopup(false);
                    }}
                    PaperProps={{
                        style: {
                            position: 'absolute',
                            top: '5rem'
                        }
                    }}
                >
                    <div className="dialog-bg bg-inputbox-color relative p-4">
                        {/* Close Button */}
                        <CloseIcon
                            className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
                            onClick={() => setShowPopup(false)}
                        />
                        <div className="text-white">
                            <h2 className="text-lg font-semibold mb-2">{t("casino.realMoneyGameOnly")}</h2>
                            <p className="text-sm text-zinc-400 mb-4">
                                {t("casino.playChipsNotSupported")}
                            </p>

                            <div className="flex justify-center">
                                <button
                                    type="button"
                                    className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                    onClick={() => {
                                        setShowPopup(false);
                                        setPendingGameLink("");
                                    }}
                                >
                                    {t("common.close")}
                                </button>
                                {/* <button
                                    type="button"
                                    className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                    onClick={() => {
                                        if (pendingGameLink) {
                                            navigate(pendingGameLink);
                                            setShowPopup(false);
                                        }
                                    }}
                                >
                                    Launch Game
                                </button> */}
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        homeData: state.userDetails?.homeData,
        banners: state.userDetails?.banners,
        exchAuthData: state.userDetails?.exchData,
        sbAuthData: state.userDetails?.sbData,
        activeWallet: state.userDetails?.activeWallet,
        userDetails: state.userDetails?.userDetails,
        dynamicTextColors: state.userDetails?.dynamicTextColors,
        siteConfig: state.userDetails?.siteConfig,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setHomeData: (data: any) => {
            dispatch(setHomeData(data));
        },
        setBanners: (data: any) => {
            dispatch(setBanners(data));
        },
        getGameUrl: (provider: string) => {
            dispatch(getGameUrl(provider));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);

